export default function SkillTag({ children, variant = 'technical' }) { return <span className={`document-skill-tag document-skill-tag--${variant}`}>{children}</span>; }
